import { SuccessStatus } from "../Status/SuccessStatus"
import { BadStatus } from "../Status/BadStatus"
import { WarningStatus } from "../Status/WarningStatus"
import { BoxWrapper, GridWrapper } from "../Wrappers/Wrappers"
import { Text, Title } from "../units/Text"
import { FlexWrapper } from "../Wrappers/Wrappers"
import { DetailText } from "../units/Text"
// import { CommissionViewProps } from "../../pages/ACBView/ACBView"
import { CommisionProps } from "../../interfaces/Commission/types"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { hasPermission } from "../../roles/roles"
import { Loader } from "../units/Loader"


const noData = 'Нет данных'

function documentationHref(url: string | null): string | undefined {
    if (!url) {
        return undefined
    }
    if (/^https?:\/\//i.test(url)) {
        return url
    }
    return `${process.env.REACT_APP_DJANGO_SERVER_URL}${url}`
}

export const ServiceInfo = (serialNumber:string,  commission: CommisionProps | null | undefined) => {
    const { user } = useSignedInContext()
    
    if (commission === null || commission === undefined) {
        return (
            <Loader/>
        )
    } 
    return (
        <BoxWrapper p="p0">
            <BoxWrapper p="p2" bg="bg-primary" r="r15" style={{position: "sticky", top: "0rem", zIndex:"1000"}}>
                { !commission.is_commissioned ? (
                    <FlexWrapper alignItems="center">
                        <Text className="bold" size="xxl">Требует ввода в эксплуатацию</Text>
                        {
                            hasPermission({role:user.role, resource:'Commission', action:'setCommissionOptions'}) &&
                                <DetailText
                                    bg="bg-secondary" 
                                    p="p1" 
                                    r="r10" 
                                    color="light" 
                                    className="bold" 
                                    href={`/react/acb/${serialNumber}/set-commission-props`}>Задать значение справочников
                                </DetailText>
                        }
                        { hasPermission({role:user.role, resource:'Commission', action:'update'}) ? (
                            <DetailText bg="bg-secondary" p="p1" r="r10" color="light" className="bold" href={`/react/acb/${serialNumber}/update-commission`}>Заполнить данные</DetailText>
                        ) : (<></>) }
                    </FlexWrapper>
                    ) : (
                    <FlexWrapper alignItems="center">
                        <Text className="bold" size="xxl">Введен в эксплуатацию</Text>
                        <FlexWrapper className="narrow-gap">
                            <DetailText bg="bg-secondary" p="p1" r="r10" color="light" className="bold" href={`/react/acb/${serialNumber}/comission-update-comment`}>Обновить комментарий</DetailText>
                        </FlexWrapper>
                    </FlexWrapper>
                    ) }
            </BoxWrapper>
            <br />
            <Text size="lg" className="bold p1">Фото</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Изображение</Text>
                            <Text isBlock={true} color="secondary">{ commission.image ? 'Выбрано' : noData }</Text>
                        </BoxWrapper>
                        { commission.image ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>
            <br />
            <Text size="lg" className="bold p1">Бизнес свойства</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Номер заказа</Text>
                            <Text isBlock={true} color="secondary">{ commission.order_number ? commission.order_number : noData }</Text>
                        </BoxWrapper>
                        { commission.voltage ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>
            <br />
            <Text size="lg" className="bold p1">Физические свойства</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Номинальное напряжение</Text>
                            <Text isBlock={true} color="secondary">{ commission.voltage ? commission.voltage + ' В' : noData }</Text>
                        </BoxWrapper>
                        { commission.voltage ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Номинальная емкость</Text>
                            <Text isBlock={true} color="secondary">{ commission.nominal_capacity ? commission.nominal_capacity + ' Ач' : noData }</Text>
                        </BoxWrapper>
                        { commission.nominal_capacity ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Вес</Text>
                            <Text isBlock={true} color="secondary">{ commission.weight ? commission.weight + ' Кг' : noData }</Text>
                        </BoxWrapper>
                        { commission.weight ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Габаритные размеры</Text>
                            <Text isBlock={true} color="secondary">{ commission.size ? commission.size : noData }</Text>
                        </BoxWrapper>
                        { commission.size ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Срок службы</Text>
                            <Text isBlock={true} color="secondary">{ commission.cycle_capacity ? commission.cycle_capacity : noData }</Text>
                        </BoxWrapper>
                        { commission.cycle_capacity ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>
            <br />
            <Text size="lg" className="bold p1">Исполнение</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение</Text>
                            <Text isBlock={true} color="secondary">{ commission.accumulator_activity ? commission.accumulator_activity  : noData }</Text>
                        </BoxWrapper>
                        { commission.accumulator_activity ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                {/* <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение охлаждение</Text>
                            <Text isBlock={true} color="secondary">{ commission.is_cooling_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper> */}

                {/* <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение отопление</Text>
                            <Text isBlock={true} color="secondary">{ commission.is_heating_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение по умолчанию</Text>
                            <Text isBlock={true} color="secondary">{ commission.is_default_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение водоустойчевость</Text>
                            <Text isBlock={true} color="secondary">{ commission.is_waterproof_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper> */}
            </GridWrapper>
            <br />
            <Text size="lg" className="bold p1">Прочее</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Артикул</Text>
                            <Text isBlock={true} color="secondary">{ commission.sku ? commission.sku : noData }</Text>
                        </BoxWrapper>
                        { commission.sku ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Тип химии</Text>
                            <Text isBlock={true} color="secondary">{ commission.chemistry ?  
                                (
                                    commission.chemistry_choices.find(choice => choice.value === commission?.chemistry)?.label
                                ) : (
                                    noData
                                ) }
                            </Text>
                        </BoxWrapper>
                        { commission.chemistry ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Тип элементов</Text>
                            <Text isBlock={true} color="secondary">{ commission.accumulator_element ? 
                                (
                                    commission.accumulator_element
                                ) : (
                                    noData
                                ) 
                            }</Text>
                        </BoxWrapper>
                        { commission.accumulator_element ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Код партии элементов</Text>
                            <Text isBlock={true} color="secondary">{ commission.batch_code ? commission.batch_code : noData }</Text>
                        </BoxWrapper>
                        { commission.batch_code ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Серия АКБ</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.accumulator_model_name ? (
                                    commission.accumulator_model_name
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.accumulator_model_name ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Тип контакторов</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.accumulator_contactor ? (
                                    commission.accumulator_contactor
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.accumulator_contactor ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Доп. оборудование</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.accumulator_additional_equipment ? (
                                    commission.accumulator_additional_equipment
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.accumulator_additional_equipment ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Датчик тока</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.accumulator_current_sensor ? (
                                    commission.accumulator_current_sensor
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.accumulator_current_sensor ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Разъем заряда</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.accumulator_charge_connector ? (
                                    commission.accumulator_charge_connector
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.accumulator_charge_connector ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Разъем разряда</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.accumulator_discharge_connector ? (
                                    commission.accumulator_discharge_connector
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.accumulator_discharge_connector ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                {/* TODO
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия прошивки BMS (SW)</Text>
                            <Text isBlock={true} color="secondary">{ commission.cycle_capacity ? commission.cycle_capacity : noData }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper> */}
            </GridWrapper>
            <br/>
            <Text size="lg" className="bold p1">BMS</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Модель BMS</Text>
                            <Text isBlock={true} color="secondary">{ commission.accumulator_bms_model ? commission.accumulator_bms_model : noData }</Text>
                        </BoxWrapper>
                        { commission.accumulator_bms_model ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия HW BMS</Text>
                            <Text isBlock={true} color="secondary">{ commission.bms_hw_version ? commission.bms_hw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.bms_hw_version ? <SuccessStatus/> : <WarningStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15" style={{gridColumn: 2}}>
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия FW BMS</Text>
                            <Text isBlock={true} color="secondary">{ commission.bms_fw_version ? commission.bms_fw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.bms_fw_version ? <SuccessStatus/> : <WarningStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>

            <br/>
            <Text size="lg" className="bold p1">Внешний пульт</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Внешний пульт</Text>
                            <Text isBlock={true} color="secondary">{ commission.accumulator_external_remote_control ? commission.accumulator_external_remote_control : noData }</Text>
                        </BoxWrapper>
                        { commission.accumulator_external_remote_control ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия HW Внешнего пульта</Text>
                            <Text isBlock={true} color="secondary">{ commission.accumulator_external_remote_control_hw_version ? commission.accumulator_external_remote_control_hw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.accumulator_external_remote_control_hw_version ? <SuccessStatus/> : <WarningStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15" style={{gridColumn: 2}}>
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия FW Внешнего пульта</Text>
                            <Text isBlock={true} color="secondary">{ commission.accumulator_external_remote_control_fw_version ? commission.accumulator_external_remote_control_fw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.accumulator_external_remote_control_fw_version ? <SuccessStatus/> : <WarningStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>

            <br />
            <Text size="lg" className="bold p1">Администация</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Ответственный за ввод карточки АКБ</Text>
                            <Text isBlock={true} color="secondary">{ commission.responsible?.full_name ? commission.responsible.full_name : noData }</Text>
                        </BoxWrapper>
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Комментарий</Text>
                            <Text isBlock={true} color="secondary">{ commission.comment ? commission.comment : noData }</Text>
                        </BoxWrapper>
                        { commission.comment ? <SuccessStatus/> : <WarningStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Дата прохождения инициализации</Text>
                            <Text isBlock={true} color="secondary">{ commission.created_at ? new Date(commission.created_at).toLocaleString('sv-SE', { timeZone: 'Europe/Moscow' }).replace('T', ' ') : noData }</Text>
                        </BoxWrapper>
                        { commission.created_at ? <SuccessStatus/> : <WarningStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>

            <br />
            <Text size="lg" className="bold p1">Конструкторская документация</Text>
            <GridWrapper>
                {commission.documentations?.length ? (
                    commission.documentations.map((doc) => {
                        const href = documentationHref(doc.url)
                        return (
                            <BoxWrapper bg="bg-primary" r="r15" key={doc.id}>
                                <FlexWrapper>
                                    <BoxWrapper p="p0">
                                        <Text className="bold">{doc.title}</Text>
                                        <Text isBlock={true} color="secondary">
                                            {href ? <DetailText href={href}>Скачать</DetailText> : noData}
                                        </Text>
                                    </BoxWrapper>
                                    {href ? <SuccessStatus/> : <WarningStatus/>}
                                </FlexWrapper>
                            </BoxWrapper>
                        )
                    })
                ) : (
                    <BoxWrapper bg="bg-primary" r="r15">
                        <FlexWrapper>
                            <BoxWrapper p="p0">
                                <Text className="bold">Документация</Text>
                                <Text isBlock={true} color="secondary">{noData}</Text>
                            </BoxWrapper>
                            <WarningStatus/>
                        </FlexWrapper>
                    </BoxWrapper>
                )}
            </GridWrapper>

        </BoxWrapper>
    )
}